import { render, staticRenderFns } from "./FutureMeSetup.vue?vue&type=template&id=155d644e&scoped=true&"
import script from "./FutureMeSetup.vue?vue&type=script&lang=js&"
export * from "./FutureMeSetup.vue?vue&type=script&lang=js&"
import style0 from "./FutureMeSetup.vue?vue&type=style&index=0&id=155d644e&scoped=true&lang=css&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "155d644e",
  null
  
)

export default component.exports